function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Fragment, useState } from "react";
import "./trendGraph.scss";
/*
  partyAcronym: '',
  partyColor: '',
  partyPercent: 0
*/

const PartiesTrend = {
  left: ["PSOE", "UNIDAS PODEMOS", "ERC-SOBIRANISTES", "EH Bildu", "PACMA", "EN MAREA"],
  right: ["PP", "Cs", "VOX", "JxCAT-JUNTS", "EAJ-PNV", "COMPROMÍS 2019"]
};

const orderData = data => {
  let ordererData = {
    left: {
      percent: 0,
      seats: 0,
      parties: []
    },
    others: {
      percent: 0,
      seats: 0,
      parties: []
    },
    right: {
      percent: 0,
      seats: 0,
      parties: []
    }
  };
  data.partiesResult.forEach(party => {
    if (PartiesTrend.left.indexOf(party.partyAcronym) > -1) {
      ordererData.left.parties.push(party);
      ordererData.left.percent += party.seats / data.totalSeats;
      ordererData.left.seats += party.seats;
    } else if (PartiesTrend.right.indexOf(party.partyAcronym) > -1) {
      ordererData.right.parties.push(party);
      ordererData.right.percent += party.seats / data.totalSeats;
      ordererData.right.seats += party.seats;
    } else {
      ordererData.others.parties.push(party);
      ordererData.others.percent += party.seats / data.totalSeats;
      ordererData.others.seats += party.seats;
    }
  });
  ordererData.right.parties.reverse();
  return ordererData;
};

const TrendGraph = ({
  data
}) => {
  const _useState = useState({
    x: null,
    y: null
  }),
        _useState2 = _slicedToArray(_useState, 2),
        mousePos = _useState2[0],
        setMousePos = _useState2[1];

  const _useState3 = useState(),
        _useState4 = _slicedToArray(_useState3, 2),
        selectedParty = _useState4[0],
        setSelectedParty = _useState4[1];

  const mouseEnter = (e, party) => {
    setMousePos({
      x: e.clientX,
      y: e.clientY
    });
    setSelectedParty(party);
  };

  const mouseLeave = () => {
    setMousePos({
      x: null,
      y: null
    });
  };

  if (!data.partiesResult) {
    return React.createElement("div", null, "Loading");
  }

  const ordererData = orderData(data);
  return React.createElement(Fragment, null, React.createElement("div", {
    className: "trendGraph"
  }, React.createElement("div", {
    className: "trendGraph_container"
  }, React.createElement("div", {
    className: "trendGraph_bars"
  }, React.createElement("div", {
    className: "trendGraph_bar trendGraph_bar_left",
    style: {
      width: ordererData.left.seats / data.totalSeats * 100 + "%"
    }
  }, React.createElement("h3", {
    className: "trendGraph_bar_title"
  }, React.createElement("span", {
    className: "trendGraph_bar_title_txt"
  }, "BLOQUE DE IZQUIERDA (", ordererData.left.seats, ")")), ordererData.left.parties.map(party => {
    return React.createElement("div", {
      className: "trendGraph_bar_content",
      key: party.partyAcronym,
      style: {
        backgroundColor: party.partyColor,
        width: party.seats / ordererData.left.seats * 100 + "%"
      },
      onMouseMove: e => mouseEnter(e, party),
      onMouseLeave: () => mouseLeave()
    }, React.createElement("span", {
      className: "trendGraph_bar_txt"
    }, party.seats));
  })), React.createElement("div", {
    className: "trendGraph_bar trendGraph_bar_center",
    style: {
      width: ordererData.others.seats / data.totalSeats * 100 + "%"
    }
  }, React.createElement("h3", {
    className: "trendGraph_bar_title"
  }, " "), ordererData.others.parties.map(party => {
    return React.createElement("div", {
      className: "trendGraph_bar_content",
      key: party.partyAcronym,
      style: {
        backgroundColor: party.partyColor,
        width: party.seats / ordererData.others.seats * 100 + "%"
      },
      onMouseMove: e => mouseEnter(e, party),
      onMouseLeave: () => mouseLeave()
    }, React.createElement("span", {
      className: "trendGraph_bar_txt"
    }, party.seats));
  })), React.createElement("div", {
    className: "trendGraph_bar trendGraph_bar_right",
    style: {
      width: ordererData.right.seats / data.totalSeats * 100 + "%"
    }
  }, React.createElement("h3", {
    className: "trendGraph_bar_title"
  }, React.createElement("span", {
    className: "trendGraph_bar_title_txt"
  }, "BLOQUE DE DERECHA (", ordererData.right.seats, ")")), ordererData.right.parties.map(party => {
    return React.createElement("div", {
      className: "trendGraph_bar_content",
      key: party.partyAcronym,
      style: {
        backgroundColor: party.partyColor,
        width: party.seats / ordererData.right.seats * 100 + "%"
      },
      onMouseMove: e => mouseEnter(e, party),
      onMouseLeave: () => mouseLeave()
    }, React.createElement("span", {
      className: "trendGraph_bar_txt"
    }, party.seats));
  })), React.createElement("div", {
    className: "trendGraph_line"
  }, React.createElement("div", {
    className: "trendGraph_line_txt"
  }, "Mayor\xEDa absoluta", React.createElement("span", {
    className: "trendGraph_line_number"
  }, Math.trunc(data.totalSeats / 2 + 1)))))), mousePos.x && React.createElement("div", {
    className: "trendGraph_tooltip",
    style: {
      position: "fixed",
      left: mousePos.x + 15,
      top: mousePos.y - 5,
      borderLeft: "10px solid " + selectedParty.partyColor
    }
  }, React.createElement("h3", {
    className: "partyName"
  }, selectedParty.partyAcronym), React.createElement("p", {
    className: "partySeats"
  }, selectedParty.seats, " esca\xF1os"), React.createElement("p", {
    className: "partyVotes"
  }, Number(selectedParty.votesPercent).toLocaleString("es"), " %", " "))));
};

export default TrendGraph;